module.exports = __webpack_public_path__ + "img/c2d4b13f35874c4d8c67c7ab3ccab331.3fcab4b2.jpg";